const loginTranslations = {
  en: {
    pageTitle: "Login",
    heroTitle: "Login",
    heroDesc: "Access your account",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    loginBtn: "Login",
    loggingIn: "Logging in...",
    forgotPassword: "Forgot Password?",
    error: "Login failed. Please check your credentials.",
    success: "Login successful!",
  },
  pa: {
    pageTitle: "ਲੌਗਇਨ",
    heroTitle: "ਲੌਗਇਨ",
    heroDesc: "ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਦਾਖਲ ਹੋਵੋ",
    emailPlaceholder: "ਈਮੇਲ",
    passwordPlaceholder: "ਪਾਸਵਰਡ",
    loginBtn: "ਲੌਗਇਨ",
    loggingIn: "ਲੌਗਇਨ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    forgotPassword: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
    error: "ਲੌਗਇਨ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਜਾਣਕਾਰੀ ਜਾਂਚੋ।",
    success: "ਲੌਗਇਨ ਸਫਲ!",
  },
};

export default loginTranslations;
